var render = function render(){
  var _vm$projectData, _vm$projectData$proje, _vm$paymentData, _vm$paymentData2, _vm$paymentData3, _vm$paymentData4, _vm$paymentData5, _vm$paymentData6, _vm$paymentData7;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSavePaymentList.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "p-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-row', [((_vm$projectData = _vm.projectData) === null || _vm$projectData === void 0 ? void 0 : (_vm$projectData$proje = _vm$projectData.project_contract_plan) === null || _vm$projectData$proje === void 0 ? void 0 : _vm$projectData$proje.length) > 0 ? _c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center align-middle",
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('b-form-checkbox', {
    on: {
      "change": _vm.toggleSelectAll
    },
    model: {
      value: _vm.selectAllPlans,
      callback: function callback($$v) {
        _vm.selectAllPlans = $$v;
      },
      expression: "selectAllPlans"
    }
  })], 1), _c('th', {
    staticClass: "text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Number Detail Plan")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "colspan": 2
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Fleet")])]), _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Cargo Type")])]), _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Draught Type")])]), _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Location")])]), _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Shipment Month")])]), _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Plan Date")])]), _c('th', {
    staticClass: "text-truncate text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Plan Quantity")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Description")])]), _c('th', {
    staticClass: "text-truncate align-middle",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Remarks")])])]), _c('tr', [_c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Ownership")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Fleets")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Type")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {}, [_c('span', {
    staticClass: "text-capitalize text-truncate"
  }, [_vm._v(" Acc. Date ")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Terms")]), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Port Of Loading")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("Port Of Dhischarge")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("ETA POL")])]), _c('th', {
    staticClass: "text-truncate"
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v("ETA POD")])])])]), _c('tbody', _vm._l(_vm.projectData.project_contract_plan, function (plan) {
    var _vm$fleetOptions, _vm$fleetOptions$find, _vm$optionsCargoType, _vm$optionsCargoType$, _vm$optionsProjectTer, _vm$optionsProjectTer2;
    return _c('tr', {
      key: plan.id
    }, [_c('td', {
      staticClass: "text-center align-middle"
    }, [_c('b-form-checkbox', {
      attrs: {
        "value": plan.id
      },
      model: {
        value: _vm.form.plan_ids,
        callback: function callback($$v) {
          _vm.$set(_vm.form, "plan_ids", $$v);
        },
        expression: "form.plan_ids"
      }
    })], 1), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(plan.shipment_plan_detail_number) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(plan.fleet_ownership === 'own-ship' ? 'Ownership' : 'Chartered') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(((_vm$fleetOptions = _vm.fleetOptions) === null || _vm$fleetOptions === void 0 ? void 0 : (_vm$fleetOptions$find = _vm$fleetOptions.find(function (opt) {
      return opt.value === plan.fleet_id;
    })) === null || _vm$fleetOptions$find === void 0 ? void 0 : _vm$fleetOptions$find.text) || plan.fleet_id || '-') + " ")])]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(((_vm$optionsCargoType = _vm.optionsCargoType) === null || _vm$optionsCargoType === void 0 ? void 0 : (_vm$optionsCargoType$ = _vm$optionsCargoType.find(function (opt) {
      return opt.value === plan.cargo_type_id;
    })) === null || _vm$optionsCargoType$ === void 0 ? void 0 : _vm$optionsCargoType$.text) || plan.cargo_type_id || '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(plan.acceptance_date ? _vm.moment(plan.acceptance_date).format('DD/MM/YYYY') : '-') + " ")]), _c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(((_vm$optionsProjectTer = _vm.optionsProjectTerms) === null || _vm$optionsProjectTer === void 0 ? void 0 : (_vm$optionsProjectTer2 = _vm$optionsProjectTer.find(function (opt) {
      return opt.value === plan.terms_id;
    })) === null || _vm$optionsProjectTer2 === void 0 ? void 0 : _vm$optionsProjectTer2.text) || plan.terms_id || '-') + " " + _vm._s(plan.terms_remarks ? ' - ' + plan.terms_remarks : '') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(plan.draught_type === 'draught_survey_loading' ? 'Draught Survey Loading' : plan.draught_type === 'draught_survey_discharge' ? 'Draught Survey Discharge' : plan.draught_type || '-') + " ")])]), _c('td', {
      staticClass: "text-left align-top"
    }, _vm._l(plan.pol, function (statePol, i) {
      var _plan$pol, _vm$positionListTextP, _vm$positionListTextP2;
      return _c('div', {
        key: i,
        staticClass: "d-flex align-items-start",
        class: {
          'mb-2': ((_plan$pol = plan.pol) === null || _plan$pol === void 0 ? void 0 : _plan$pol.length) > 1
        },
        staticStyle: {
          "width": "240px"
        }
      }, [_c('div', {
        staticClass: "w-100 mr-2"
      }, [_c('span', {
        staticClass: "form-control-plaintext"
      }, [_vm._v(" " + _vm._s(((_vm$positionListTextP = _vm.positionListTextPOL) === null || _vm$positionListTextP === void 0 ? void 0 : (_vm$positionListTextP2 = _vm$positionListTextP.find(function (opt) {
        return opt.value === statePol.value;
      })) === null || _vm$positionListTextP2 === void 0 ? void 0 : _vm$positionListTextP2.text) || (statePol.value === 'other' ? statePol.valueOther : statePol.value) || '-') + " ")])])]);
    }), 0), _c('td', {
      staticClass: "text-left align-top"
    }, _vm._l(plan.pod, function (statePol, i) {
      var _plan$pod, _vm$positionListTextP3, _vm$positionListTextP4;
      return _c('div', {
        key: i,
        staticClass: "d-flex align-items-start",
        class: {
          'mb-2': ((_plan$pod = plan.pod) === null || _plan$pod === void 0 ? void 0 : _plan$pod.length) > 1
        },
        staticStyle: {
          "width": "240px"
        }
      }, [_c('div', {
        staticClass: "w-100 mr-2"
      }, [_c('span', {
        staticClass: "form-control-plaintext"
      }, [_vm._v(" " + _vm._s(((_vm$positionListTextP3 = _vm.positionListTextPOD) === null || _vm$positionListTextP3 === void 0 ? void 0 : (_vm$positionListTextP4 = _vm$positionListTextP3.find(function (opt) {
        return opt.value === statePol.value;
      })) === null || _vm$positionListTextP4 === void 0 ? void 0 : _vm$positionListTextP4.text) || (statePol.value === 'other' ? statePol.valueOther : statePol.value) || '-') + " ")])])]);
    }), 0), _c('td', {
      staticClass: "text-truncate"
    }, [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(plan.shipment || '-') + " ")])]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(plan.eta_pol ? _vm.moment(plan.eta_pol).format('DD MMM YYYY') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(plan.eta_pod ? _vm.moment(plan.eta_pod).format('DD MMM YYYY') : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(plan.plan_quantity ? plan.plan_quantity.toLocaleString('id-ID') + ' MT' : '-') + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(plan.description || '-') + " ")])]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('span', {
      staticClass: "form-control-plaintext"
    }, [_vm._v(" " + _vm._s(plan.terms_remarks || '-') + " ")])])]);
  }), 0)])])]) : _vm._e(), _vm.form.plan_ids && _vm.form.plan_ids.length ? [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Request Name *"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "required": "",
      "placeholder": "Type Text",
      "type": "text"
    },
    model: {
      value: _vm.form.request_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "request_name", $$v);
      },
      expression: "form.request_name"
    }
  }) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(_vm.paymentData.request_name) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Request Date *"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? [_c('date-picker', {
    staticClass: "w-100",
    attrs: {
      "placeholder": "Select Date",
      "value-type": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.request_date,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "request_date", $$v);
      },
      expression: "form.request_date"
    }
  })] : _c('strong', [_vm._v(" " + _vm._s(_vm.paymentData.request_date ? _vm.moment(_vm.paymentData.request_date).format('DD/MM/YYYY') : '-') + " ")])], 2), _c('b-form-group', {
    attrs: {
      "label": "Customer Order Nbr. *"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "required": "",
      "placeholder": "Type Text",
      "type": "text"
    },
    model: {
      value: _vm.form.customer_order_nbr,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customer_order_nbr", $$v);
      },
      expression: "form.customer_order_nbr"
    }
  }) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(_vm.paymentData.customer_order_nbr) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Transaction Description *"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "required": "",
      "placeholder": "Type Text",
      "type": "text"
    },
    model: {
      value: _vm.form.transaction_description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "transaction_description", $$v);
      },
      expression: "form.transaction_description"
    }
  }) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(_vm.paymentData.transaction_description) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Branch"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "value",
      "options": _vm.branchOpt,
      "placeholder": "Select Branch",
      "track-by": "value",
      "label": "label",
      "reduce": function reduce(obj) {
        return obj.value;
      },
      "getOptionKey": function getOptionKey(option) {
        return option.label;
      },
      "required": ""
    },
    model: {
      value: _vm.form.branch_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "branch_id", $$v);
      },
      expression: "form.branch_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Tax Category"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "value",
      "options": _vm.taxCategoryOpt,
      "placeholder": "Select Tax Category",
      "track-by": "value",
      "label": "label",
      "reduce": function reduce(obj) {
        return obj.value;
      },
      "getOptionKey": function getOptionKey(option) {
        return option.label;
      },
      "required": ""
    },
    model: {
      value: _vm.form.tax_category_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tax_category_id", $$v);
      },
      expression: "form.tax_category_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Real Pricing *"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "required": "",
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: _vm.form.real_pricing,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "real_pricing", $$v);
      },
      expression: "form.real_pricing"
    }
  }) : _vm._e(), ['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-text', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.form.real_pricing)) + " ")]) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.paymentData.real_pricing)) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Invoice Price *"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    on: {
      "change": function change() {
        _vm.onChangeInvoicePrice();
        _vm.countTaxTotal();
      }
    },
    model: {
      value: _vm.form.invoice_price,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "invoice_price", $$v);
      },
      expression: "form.invoice_price"
    }
  }) : _vm._e(), ['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-text', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.form.invoice_price)) + " ")]) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.paymentData.invoice_price)) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Balance"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: _vm.form.balance,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "balance", $$v);
      },
      expression: "form.balance"
    }
  }) : _vm._e(), ['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-text', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.form.balance)) + " ")]) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.paymentData.balance)) + " ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Tax Total"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "placeholder": "0",
      "type": "number",
      "disabled": true
    },
    model: {
      value: _vm.form.tax_total,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tax_total", $$v);
      },
      expression: "form.tax_total"
    }
  }) : _vm._e(), ['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-text', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.form.tax_total)) + " ")]) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.paymentData.tax_total)) + " ")]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }), _vm.form.use_tax ? [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tax Name *"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "placeholder": "Type Text",
      "type": "text"
    },
    model: {
      value: _vm.form.name_tax,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name_tax", $$v);
      },
      expression: "form.name_tax"
    }
  }) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(_vm.paymentData.name_tax) + " ")]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tax Percentage (%)"
    }
  }, [['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-input', {
    attrs: {
      "placeholder": "0.00",
      "type": "number",
      "step": "0.001"
    },
    on: {
      "change": function change() {
        _vm.countTaxTotal();
      }
    },
    model: {
      value: _vm.form.tax_percentage,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tax_percentage", $$v);
      },
      expression: "form.tax_percentage"
    }
  }) : _vm._e(), ['PREVIEW'].includes(_vm.action) ? _c('strong', [_vm._v(" " + _vm._s(parseFloat(_vm.paymentData.tax_percentage).toLocaleString()) + "% ")]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  })] : _vm._e(), _vm.form.is_deduction ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex w-100 align-items-center justify-content-between mb-2"
  }, [_c('h6', [_c('strong', [_vm._v("Deduction")])]), ['ADD', 'EDIT'].includes(_vm.action) ? _c('b-button', {
    attrs: {
      "variant": "success",
      "type": "button"
    },
    on: {
      "click": _vm.addDeduction
    }
  }, [_c('i', {
    staticClass: "fa fa-plus pr-0"
  }), _vm._v(" ADD MORE DEDUCTION ")]) : _vm._e()], 1), _c('div', {
    staticClass: "overflow-auto",
    staticStyle: {
      "max-height": "400px"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "vertical-align": "middle",
      "width": "20px"
    }
  }, [_vm._v(" # ")]), _c('th', {
    staticClass: "text-center text-truncate",
    staticStyle: {
      "vertical-align": "middle",
      "width": "250px"
    }
  }, [_vm._v(" Name ")]), _c('th', {
    staticClass: "text-center text-truncate",
    staticStyle: {
      "vertical-align": "middle",
      "width": "250px"
    }
  }, [_vm._v(" Amount ")]), _c('th', {
    staticClass: "text-center text-truncate",
    staticStyle: {
      "vertical-align": "middle",
      "width": "250px"
    }
  }, [_vm._v(" Remarks ")]), _c('th', {
    staticClass: "text-center text-truncate",
    staticStyle: {
      "vertical-align": "middle",
      "width": "250px"
    }
  }, [_vm._v(" File ")])])]), ['ADD', 'EDIT'].includes(_vm.action) ? _c('tbody', _vm._l(_vm.form.deduction, function (state, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center align-top"
    }, [index !== 0 ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function click() {
          _vm.form.deduction.splice(index, 1);
          _vm.form.invoice_price += state.amount;
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash pr-0"
    })]) : _vm._e()], 1), _c('td', {
      staticClass: "align-top"
    }, [_c('b-form-input', {
      attrs: {
        "placeholder": "Type Text"
      },
      model: {
        value: state.name,
        callback: function callback($$v) {
          _vm.$set(state, "name", $$v);
        },
        expression: "state.name"
      }
    })], 1), _c('td', {
      staticClass: "align-top"
    }, [_c('b-form-input', {
      attrs: {
        "placeholder": "Type Number"
      },
      model: {
        value: state.amount,
        callback: function callback($$v) {
          _vm.$set(state, "amount", $$v);
        },
        expression: "state.amount"
      }
    }), ['EDIT', 'ADD'].includes(_vm.action) ? _c('b-form-text', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(state.amount)) + " ")]) : _vm._e()], 1), _c('td', {
      staticClass: "align-top"
    }, [_c('b-form-input', {
      attrs: {
        "placeholder": "Type Text"
      },
      model: {
        value: state.remarks,
        callback: function callback($$v) {
          _vm.$set(state, "remarks", $$v);
        },
        expression: "state.remarks"
      }
    })], 1), _c('td', [_c('b-form-file', {
      attrs: {
        "id": 'fileSupport' + index,
        "placeholder": "Choose a file",
        "accept": "application/pdf"
      },
      model: {
        value: state.file,
        callback: function callback($$v) {
          _vm.$set(state, "file", $$v);
        },
        expression: "state.file"
      }
    }), _c('span', {
      staticClass: "text-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview(state === null || state === void 0 ? void 0 : state.file_url, state === null || state === void 0 ? void 0 : state.file_name);
        }
      }
    }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : state.file_name) + " ")])], 1)]);
  }), 0) : _c('tbody', _vm._l(_vm.paymentData.deduction, function (state, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center align-top"
    }, [_vm._v("#")]), _c('td', {
      staticClass: "text-center align-top"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.name))]), _c('td', {
      staticClass: "text-center align-top"
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(state.amount)) + " ")]), _c('td', {
      staticClass: "text-center align-top"
    }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : state.remarks) + " ")]), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "text-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview(state === null || state === void 0 ? void 0 : state.file_url, state === null || state === void 0 ? void 0 : state.file_name);
        }
      }
    }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : state.file_name) + " ")])])]);
  }), 0), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total Amount")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.totalAmount)) + " ")]), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })])])])])]) : _vm._e(), (_vm$paymentData = _vm.paymentData) !== null && _vm$paymentData !== void 0 && _vm$paymentData.real_invoice_fulfilled && ['PREVIEW'].includes(_vm.action) ? _c('b-col', {
    staticClass: "p-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Real Invoice Number"
    }
  }, [_c('strong', [_vm._v(_vm._s((_vm$paymentData2 = _vm.paymentData) === null || _vm$paymentData2 === void 0 ? void 0 : _vm$paymentData2.real_invoice_number))])])], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Invoice Date"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s((_vm$paymentData3 = _vm.paymentData) !== null && _vm$paymentData3 !== void 0 && _vm$paymentData3.invoice_date ? _vm.moment((_vm$paymentData4 = _vm.paymentData) === null || _vm$paymentData4 === void 0 ? void 0 : _vm$paymentData4.invoice_date).format('DD MMM YYYY') : '-') + " ")])])], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Due Date"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s((_vm$paymentData5 = _vm.paymentData) !== null && _vm$paymentData5 !== void 0 && _vm$paymentData5.due_date ? _vm.moment((_vm$paymentData6 = _vm.paymentData) === null || _vm$paymentData6 === void 0 ? void 0 : _vm$paymentData6.due_date).format('DD MMM YYYY') : '-') + " ")])])], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Invoice File"
    }
  }, [_vm.paymentData.real_invoice_attachment.length > 0 ? _c('div', {
    staticClass: "d-flex flex-column"
  }, _vm._l(_vm.paymentData.real_invoice_attachment, function (file, fileIndex) {
    return _c('div', {
      key: fileIndex,
      staticClass: "d-flex align-items-center mb-2",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenFilePreview(file === null || file === void 0 ? void 0 : file.file_url, file === null || file === void 0 ? void 0 : file.file_name);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file text-primary mr-2"
    }), _c('span', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s(file.file_name))])]);
  }), 0) : _vm._e()])], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status Invoice"
    }
  }, [_c('strong', {
    staticClass: "text-capitalize"
  }, [_vm._v(" " + _vm._s((_vm$paymentData7 = _vm.paymentData) === null || _vm$paymentData7 === void 0 ? void 0 : _vm$paymentData7.status) + " ")])])], 1)], 1)], 1) : _vm._e(), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "12"
    }
  }, [_c('h4', [_c('strong', [_vm._v("Invoice Total")])]), _c('div', {
    staticClass: "d-flex p-2 bg-success"
  }, [_c('h5', {
    staticClass: "text-white"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.totalInvoice)))])])])])] : _vm._e()], 2)], 1)], 1), _c('div', {
    staticClass: "w-100 d-flex mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2 w-50",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Submit")])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }